import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { URLS } from "../constants/constants";
import { isPracticallyZero } from "../utils/math";
import { getLendContract } from "./getLendContract";
import useWeb3Wallet from "./useWeb3Wallet";
import { useWeb3Context } from "./web3Context";
import { PoolAddressMap, PoolList } from "../constants/lendConstants";
export var useLendLink = function () {
    var _a = useState(false), hasLendPosition = _a[0], setHasLendPosition = _a[1];
    var account = useWeb3Wallet().account;
    var _b = useWeb3React(), active = _b.active, library = _b.library;
    var provider = useWeb3Context().provider;
    useEffect(function () {
        if (!account) {
            setHasLendPosition(false);
        }
        PoolList.forEach(function (pool) {
            var poolContract = getLendContract(library || provider, PoolAddressMap[pool].lend, active);
            if (poolContract && account) {
                poolContract.balanceOf(account).then(function (balance) {
                    if (!isPracticallyZero(balance, 6)) {
                        setHasLendPosition(true);
                    }
                });
            }
        });
    }, [account, active, library, provider]);
    return hasLendPosition ? URLS.lendApp : URLS.lend;
};
//# sourceMappingURL=useLendLink.js.map